var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M7.3,35c-0.3,0.5-0.3,1,0,1.5c0.3,0.5,0.8,0.8,1.4,0.8H20c0.3,0,0.6-0.1,0.9-0.3l0,0 c0.4,0.2,0.8,0.3,1.3,0.3c1.1,0,2.1-0.5,2.8-1.3l0,0c0.6,0.5,1.3,1,2.1,1.3h6.1c3.8-1.4,5.7-5.6,4.3-9.4c-0.8-2-2.3-3.6-4.4-4.3 v-7.4c0.6-0.1,1-0.6,1-1.2c0.1-0.7-0.5-1.3-1.2-1.4c0,0-0.1,0-0.1,0h-5.3c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0.1,0,0.1 c0,0.6,0.4,1.1,1,1.2v7.4l-1.3,0.7l0,0v-14l0,0c0.5-0.2,0.8-0.7,0.8-1.3c0-0.7-0.6-1.3-1.3-1.3c0,0,0,0,0,0h-6.5 c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0c0,0.6,0.3,1.1,0.8,1.3v17.1l-1.6-4.1v-3.7c0.6-0.1,1.1-0.6,1.1-1.2c0-0.7-0.6-1.3-1.3-1.3 c0,0,0,0,0,0h-4.5c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.5,1.2,1.2,1.2v3.7L7.3,35z M7.9,35.3l2.2-5.5c0.7,0,1.4-0.2,2-0.6l1.2-0.5 c1.2-0.2,2.3,0.6,3.6,1l1.8,0.4l2.1,5.2c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.3-0.5,0.5-0.8,0.5H8.7c-0.3,0-0.6-0.2-0.8-0.5 C7.8,35.8,7.8,35.6,7.9,35.3z M33,36.6h-5.7c-2.2-0.9-3.8-2.9-4.1-5.3c4.9,1.9,5.5-3.7,14-1.6C37.5,32.7,35.8,35.5,33,36.6z  M23.5,28.3c2.2-0.2,4.3,0.2,6.2,1.3c-1.4,0.6-3.6,2.6-6.5,1.3C23.1,30,23.2,29.1,23.5,28.3z M26.9,15c0-0.4,0.3-0.6,0.6-0.7h5.3 c0.4,0,0.6,0.3,0.6,0.7c0,0.3-0.3,0.6-0.6,0.6l0,0h-5.3C27.2,15.6,26.9,15.3,26.9,15C26.9,15,26.9,15,26.9,15z M27.9,16.3h4.5v7.5 c0,0.2,0.1,0.3,0.3,0.3c2.3,0.9,4,2.9,4.4,5.3c-2.3-0.7-4.7-0.6-7,0.1c-2-1.2-4.2-1.7-6.5-1.6c0.8-1.8,2.3-3.1,4.1-3.8 c0.1,0,0.2-0.1,0.2-0.3L27.9,16.3z M25.2,24.8c-3.1,2.4-3.7,6.8-1.4,9.9c0.2,0.3,0.4,0.5,0.7,0.8c-0.6,0.7-1.4,1-2.3,1.1h-0.8 c0.3-0.5,0.3-1,0.1-1.5l-2.4-5.9l0,0v-9.3l0,0c1,0.4,2,0.5,3.1,0.5c1,0,2-0.1,3-0.5L25.2,24.8z M22.2,18.7c1,0,2,0.1,3,0.5v0.3 c-1,0.4-2,0.5-3,0.5c-1.1,0.1-2.1-0.1-3.1-0.5l0,0v-0.3l0,0C20.1,18.8,21.1,18.6,22.2,18.7z M25.2,18.8c-1-0.3-2-0.4-3-0.4 c-1,0-2.1,0.1-3.1,0.4l0,0v-8.4h6.1V18.8z M18.3,9c0-0.3,0.3-0.6,0.6-0.6l0,0h6.5C25.7,8.4,26,8.7,26,9c0,0,0,0,0,0 c0,0.4-0.3,0.6-0.6,0.7h-6.5C18.6,9.6,18.3,9.4,18.3,9z M16.1,23.4L16.1,23.4l2.5,6.3c-0.5,0-1.1-0.1-1.6-0.3 c-1.2-0.4-2.5-1.3-3.8-1L12,28.9c-0.6,0.3-1.2,0.5-1.8,0.6l2.4-6l0,0v-3.9h3.5V23.4z M11.5,18.4c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0 h4.5c0.3-0.1,0.5,0.1,0.6,0.4c0,0.1,0,0.2,0,0.2c0,0.3-0.2,0.5-0.6,0.5h-4.5C11.8,18.9,11.5,18.7,11.5,18.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#28B557",
  d: "M8.7,36.6H20c0.3,0,0.6-0.2,0.8-0.5c0.2-0.2,0.2-0.6,0-0.8l-2.1-5.2l-1.8-0.4c-1.3-0.4-2.4-1.2-3.6-1 l-1.2,0.5c-0.6,0.4-1.3,0.6-2,0.6l-2.2,5.5c-0.1,0.3-0.1,0.5,0,0.8C8.1,36.4,8.4,36.6,8.7,36.6z M11.8,35c-0.3,0-0.6-0.3-0.6-0.6 s0.3-0.6,0.6-0.6l0,0c0.3,0,0.6,0.3,0.6,0.6S12.1,35,11.8,35z M18.2,31.9c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4c0,0,0,0,0,0 c-0.2,0-0.4-0.2-0.4-0.4S18,31.9,18.2,31.9C18.2,31.9,18.2,31.9,18.2,31.9z M16.1,33c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5C16.6,32.8,16.4,33,16.1,33z M13.6,30.5c0.3,0,0.6,0.3,0.6,0.6l0,0c0.1,0.3-0.1,0.5-0.4,0.6c-0.1,0-0.2,0-0.2,0 c-0.3,0-0.6-0.3-0.6-0.6l0,0C13,30.8,13.3,30.5,13.6,30.5C13.6,30.5,13.6,30.5,13.6,30.5z M14.2,33.6c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.3C14,33.3,14.2,33.4,14.2,33.6z M16,35.5c-0.2,0-0.4-0.3-0.4-0.5 c0-0.2,0.2-0.5,0.4-0.5c0.3,0,0.5,0.2,0.5,0.5S16.3,35.5,16,35.5z M11.1,31.3c0.2,0,0.3,0.2,0.3,0.4c0,0.2-0.1,0.3-0.3,0.3 c-0.2,0-0.4-0.1-0.4-0.3C10.7,31.5,10.9,31.3,11.1,31.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M18.9,9.7h6.5C25.7,9.6,26,9.4,26,9c0-0.3-0.3-0.6-0.6-0.6l0,0h-6.5c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0 C18.3,9.4,18.6,9.6,18.9,9.7z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M19.1,10.4v8.4l0,0c1-0.3,2.1-0.4,3.1-0.4c1,0,2,0.1,3,0.4v-8.4H19.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M12.6,19.6v3.8l0,0l-2.4,6c0.6-0.1,1.2-0.3,1.8-0.6l1.2-0.5c1.3-0.3,2.6,0.6,3.8,1c0.5,0.2,1.1,0.3,1.6,0.3 l-2.5-6.1l0,0v-3.9H12.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0451E",
  d: "M19.1,19.2v0.3l0,0c1,0.4,2,0.6,3.1,0.5c1,0,2-0.1,3-0.5v-0.3c-1-0.4-2-0.5-3-0.5 C21.1,18.6,20.1,18.8,19.1,19.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M22.2,20.4c-1.1,0-2.1-0.1-3.1-0.5l0,0v9.3l0,0l2.4,5.8c0.2,0.5,0.2,1-0.1,1.5h0.8c0.9-0.1,1.7-0.4,2.3-1.1 c-2.8-2.8-2.8-7.3-0.1-10c0.2-0.2,0.5-0.5,0.8-0.7v-4.8C24.2,20.3,23.2,20.4,22.2,20.4z M20.3,22.5c0-0.3,0.3-0.6,0.6-0.6l0,0 c0.3,0,0.5,0.2,0.5,0.6c0,0.3-0.2,0.5-0.5,0.5C20.6,23,20.3,22.8,20.3,22.5z M21.4,26.4c-0.3,0-0.5-0.2-0.5-0.5 c0-0.3,0.2-0.6,0.5-0.6c0.3,0,0.6,0.3,0.6,0.6l0,0C22,26.2,21.7,26.4,21.4,26.4z M22,28.4c0,0.3-0.3,0.6-0.6,0.6l0,0 c-0.3,0-0.5-0.3-0.5-0.6c0-0.3,0.2-0.5,0.5-0.5C21.7,27.9,22,28.1,22,28.4z M21.7,31.1c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5 s-0.5-0.2-0.5-0.5S21.4,31.1,21.7,31.1z M22.8,34.1c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 c0,0,0,0,0,0C22.7,33.8,22.8,33.9,22.8,34.1z M23.7,24.2c0,0.4-0.2,0.6-0.5,0.6c-0.3,0-0.6-0.3-0.6-0.6l0,0c0-0.3,0.3-0.5,0.6-0.5 C23.5,23.7,23.7,23.9,23.7,24.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M16.6,18.9c0.4,0,0.6-0.2,0.6-0.5c0.1-0.3-0.1-0.5-0.4-0.6c-0.1,0-0.2,0-0.2,0h-4.5c-0.3,0-0.6,0.3-0.6,0.6 l0,0c0,0.3,0.3,0.5,0.6,0.5H16.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M32.8,15.6L32.8,15.6c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0c0-0.4-0.2-0.7-0.6-0.7h-5.3 c-0.3,0.1-0.6,0.3-0.6,0.7c0,0.3,0.3,0.6,0.6,0.6l0,0H32.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M27.7,24.1c-1.8,0.7-3.3,2-4.1,3.8c2.3-0.1,4.5,0.4,6.5,1.6c2.3-0.7,4.7-0.8,7-0.1C36.7,27,35,25,32.7,24.1 c-0.2,0-0.3-0.1-0.3-0.3v-7.5h-4.5v7.5C27.9,24,27.8,24.1,27.7,24.1z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E98C0",
  d: "M29.7,29.6c-1.9-1.1-4-1.5-6.2-1.3c-0.3,0.8-0.4,1.7-0.3,2.6C26.1,32.2,28.3,30.2,29.7,29.6z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M23.2,31.3c0.3,2.4,1.9,4.4,4.1,5.3H33c2.8-1.1,4.5-3.9,4.2-6.9C28.7,27.6,28.1,33.2,23.2,31.3z M34.1,30.8 c0.3,0,0.6,0.3,0.6,0.6l0,0c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.5-0.5C33.6,31.1,33.8,30.8,34.1,30.8z M33.1,34.2 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C32.7,34.4,32.9,34.2,33.1,34.2C33.1,34.2,33.1,34.2,33.1,34.2 z M30.7,31.6c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.3-0.2-0.3-0.4C30.4,31.7,30.5,31.6,30.7,31.6z M29.9,33.9 c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7C29.2,34.2,29.5,33.9,29.9,33.9z M27.9,32.3 c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.6-0.5,0.6c-0.3,0-0.6-0.3-0.6-0.6l0,0C27.3,32.5,27.6,32.3,27.9,32.3z M26.3,34.5 c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5S27.1,35,26.8,35S26.3,34.8,26.3,34.5z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M11.1,32c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.2-0.4,0.4C10.7,31.9,10.9,32,11.1,32z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M21.4,22.5c0-0.4-0.2-0.6-0.5-0.6c-0.3,0-0.6,0.3-0.6,0.6l0,0c0,0.3,0.3,0.5,0.6,0.5 C21.2,23,21.4,22.8,21.4,22.5z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M16.1,32c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C16.6,32.2,16.4,32,16.1,32z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M23.2,23.7c-0.3,0-0.6,0.2-0.6,0.5c0,0.3,0.3,0.6,0.6,0.6l0,0c0.3,0,0.5-0.2,0.5-0.6 C23.7,23.9,23.5,23.7,23.2,23.7z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M27.3,34.5c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5S27.3,34.8,27.3,34.5z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M27.9,33.4c0.3,0,0.5-0.3,0.5-0.6c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.2-0.6,0.5 C27.3,33.1,27.6,33.4,27.9,33.4L27.9,33.4z"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 13.8,
  cy: 33.6,
  r: 0.4
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 21.4,
  cy: 25.9,
  r: 0.5
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M21.7,32.1c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5S21.4,32.1,21.7,32.1z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M29.2,34.6c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7S29.2,34.2,29.2,34.6L29.2,34.6z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M13.6,31.7c0.3,0.1,0.5-0.1,0.6-0.4c0-0.1,0-0.2,0-0.2c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0 c-0.3,0-0.6,0.3-0.6,0.6l0,0C13,31.4,13.3,31.7,13.6,31.7C13.6,31.7,13.6,31.7,13.6,31.7z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M12.4,34.4c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C12.1,35,12.4,34.7,12.4,34.4L12.4,34.4z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M16,34.5c-0.2,0-0.4,0.3-0.4,0.5c0,0.2,0.2,0.5,0.4,0.5c0.3,0,0.5-0.2,0.5-0.5S16.3,34.5,16,34.5z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M18.2,32.7c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4c0,0,0,0,0,0c-0.2,0-0.4,0.2-0.4,0.4S18,32.7,18.2,32.7 C18.2,32.7,18.2,32.7,18.2,32.7z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M21.4,27.9c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.6,0.5,0.6c0.3,0,0.6-0.3,0.6-0.6l0,0 C22,28.1,21.7,27.9,21.4,27.9z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.2,34.1c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c0,0,0,0,0,0 C22.3,33.8,22.2,33.9,22.2,34.1z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M34.1,31.9c0.3,0,0.6-0.2,0.6-0.5c0-0.3-0.3-0.6-0.6-0.6l0,0c-0.3,0-0.5,0.3-0.5,0.6 C33.6,31.7,33.8,31.9,34.1,31.9z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M30.7,32.3c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.3,0.1-0.3,0.3 C30.4,32.1,30.5,32.3,30.7,32.3z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M32.6,34.6c0,0.2,0.3,0.4,0.5,0.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4 C32.9,34.2,32.6,34.4,32.6,34.6z"
});

function SvgChemicals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicals);
export default __webpack_public_path__ + "static/media/chemicals.1730640b8a82ae12593b5598d582748c.svg";
export { ForwardRef as ReactComponent };